'use client'

import { NextUIProvider } from '@nextui-org/system'
import { ThemeProvider as NextThemesProvider } from 'next-themes'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/navigation'

import type { ReactProps } from '@/types'

const BootstrapObserver = dynamic(() => import('./bootstrap'), { ssr: false })

export function AppProvider({ children }: ReactProps) {
  // __STATE's
  const router = useRouter()

  // __RENDER
  return (
    <NextUIProvider navigate={router.push}>
      <NextThemesProvider attribute='class' defaultTheme='light'>
        <BootstrapObserver />
        {children}
      </NextThemesProvider>
    </NextUIProvider>
  )
}
